import React from 'react';
import Styles from './sorter-icon-styles.scss';
import { ArrowSorterDown, ArrowSorterUp } from '../../icons';
const SorterIcon = ({ direction = 'desc' }) => {
    return (React.createElement("div", { className: Styles.sorterIconWrap },
        React.createElement(ArrowSorterUp, { width: 10, height: 5, color: direction === 'asc' ? '#FFA800' : '#BBBBBB' }),
        React.createElement(ArrowSorterDown, { width: 10, height: 5, color: direction === 'desc' ? '#FFA800' : '#BBBBBB' })));
};
export default SorterIcon;
